import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Button, FormControl, FormHelperText, Grid, Input, InputLabel, Typography} from "@material-ui/core";
import {
  NotificationContainer,
  NotificationManager
} from "react-notifications";
import style from "./style";
import {emailRegex} from "../../config/constants";
import { forogotPassword } from '../../redux/auth';

class FPassword extends Component {
  state = {
    email: "",
    emailErr: false,
    emailErrMsg: "",
  };

  handleInputChange = e => {
    this.setState({
      errors: false,
      emailErr: false,
      emailErrMsg: ""
    });
    const { name, value } = e.target;
    switch (name) {
      default:
        return;
      case "email":
        this.setState({ email: value });
        break;
    }
  };

  checkErrors = () => {
    this.setState({ loginErr: false, loginErrMsg: "" });
    const { email } = this.state;
    if (email.trim().length <= 0) {
      this.setState({
        errors: true,
        emailErr: true,
        emailErrMsg: "Email is required"
      });
    } else if (!emailRegex.test(email.trim())) {
      this.setState({
        errors: true,
        emailErr: true,
        emailErrMsg: "Invalid Email"
      });
    } else {
      this.setState({ errors: false, emailErr: false, emailErrMsg: "" });
    }
  };

  handleBlur = e => {
    const {
      target: { name, value }
    } = e;
    if (name === "email") {
      if (value.trim().length <= 0) {
        this.setState({
          errors: true,
          emailErr: true,
          emailErrMsg: "Email is required"
        });
      } else if (!emailRegex.test(value)) {
        this.setState({
          errors: true,
          emailErr: true,
          emailErrMsg: "Invalid Email"
        });
      } else {
        this.setState({ errors: false, emailErr: false, emailErrMsg: "" });
      }
    }
  };

  handleSubmit = e => {
    e.preventDefault();

    const { dispatch } = this.props;
    const { email, errors, emailErr } = this.state;

    if(email) {
      if (!emailRegex.test(email) || errors || emailErr) {
        this.setState({
          errors: true,
          emailErr: true,
          emailErrMsg: "Invalid Email"
        });
        return;
      }

      this.setState({
        errors: false,
        emailErr: false,
        emailErrMsg: ""
      });
      dispatch(forogotPassword(email))
        .then(response => {
          NotificationManager.info("An email has been sent to your registered email.", "Forgot Password");
        })
        .catch(err => {
          this.setState({
            errors: true,
            emailErr: true,
            emailErrMsg: "No such email is registered."
          });
        });
    }else{
      this.setState({
        errors: true,
        emailErr: true,
        emailErrMsg: "Email is required"
      });
    }
    //this.props.toggleLoginDrawer();
  };

  render() {
    return (<Grid container style={{ maxWidth: 420, width: '100%', marginTop: '7%' }}>
      <Grid item xs={12} style={{ margin: "10px 0" }} />
      <Grid container justify="flex-start" style={{ paddingLeft: 20 }}>
        <Typography variant="h5" style={style.setFont} gutterBottom={true}>
          Forgot password?
        </Typography>
        <Typography variant="h6" style={{ ...style.setFont, ...style.smallTextHeader }}>
          Enter your registered email address.
        </Typography>
      </Grid>
      <Grid container style={{ marginTop: 30 }}>
        <form
          action="#!"
          method="post"
          style={{ width: "100%" }}
          onSubmit={e => this.handleSubmit(e)}
        >
          <Grid item xs={12} style={style.inputCtrl}>
            <FormControl fullWidth={true}>
              <InputLabel
                htmlFor="Email Address"
                style={
                  this.state.emailErr
                    ? { ...style.setFont, ...style.error }
                    : style.setFont
                }
              >
                Email Address
              </InputLabel>
              <Input
                error={this.state.emailErr}
                style={{ ...style.setFont }}
                onChange={this.handleInputChange}
                name="email"
                value={this.state.email}
                onBlur={this.handleBlur}
              />
              <FormHelperText
                style={
                  this.state.emailErr
                    ? { ...style.setFont, ...style.error }
                    : { ...style.setFont, ...style.msg }
                }
              >
                {this.state.emailErrMsg}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid
            item
            xs={12}
            style={{ ...style.inputCtrl, marginTop: 10 }}
          >
            <Button
            data-test-id={"submit-fp"}
              type="submit"
              variant="contained"
              disabled={this.state.loading}
              fullWidth={true}
              color="primary"
              style={style.btnLogin}
            >
              Submit
            </Button>
          </Grid>
        </form>
      </Grid>
      {/*<Grid container justify="center" alignItems="center">
        <Grid item xs={12} style={{ ...style.setFont, paddingLeft: 20, marginTop: 30 }}>
          Already have an account? <span style={style.loginHere} onClick={() => this.props.history.push('/sign-in')}>Sign in</span>
        </Grid>
      </Grid>*/}
    </Grid>);
  }
}

const mapStateToProps = (state) => {
  return {};
};

const ForgotPassword = connect(mapStateToProps)(FPassword);

export default ForgotPassword;
